// @flow

import React from 'react'
import styled from 'styled-components'
import type { Theme as ThemeType } from 'src/types'
import {
  Single,
  Single as Double,
  Bed,
  Bath,
  Kitchen,
  Cutlery,
  Bill,
  Spray,
  TShirt,
  DumbBells,
  Time,
  WiFi,
  Bell,
  Sofa,
  Laptop,
  Ban
} from 'src/components/Icons'

type Props = {
  icons: Array<any>
}

const StyledIconList = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(80px, 188px));
  grid-template-rows: repeat(auto-fill, 30px);
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  grid-row-gap: 44px;
  grid-column-gap: 62px;
  margin: 30px 5px;
`

const StyledIcon = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  color: ${(props: { theme: ThemeType }) => props.theme.darkText};

  & > :first-child {
    padding-right: 10px;
  }
`

export const IconList = ({ icons }: Props) => {
  const useIcon = strRef => {
    switch (strRef) {
      case 'Bill':
        return <Bill />
      case 'TShirt':
        return <TShirt />
      case 'Spray':
        return <Spray />
      case 'Ban':
        return <Ban />
      case 'Laptop':
        return <Laptop />
      case 'Sofa':
        return <Sofa />
      case 'Bell':
        return <Bell />
      case 'WiFi':
        return <WiFi />
      case 'Time':
        return <Time />
      case 'DumbBells':
        return <DumbBells />
      case 'Single':
        return <Single />
      case 'Double':
        return <Double />
      case 'Bed':
        return <Bed />
      case 'Bath':
        return <Bath />
      case 'Kitchen':
        return <Kitchen />
      case 'Cutlery':
        return <Cutlery />
      default:
        return <Time />
    }
  }
  return (
    <StyledIconList>
      {icons.map(icon => (
        <StyledIcon key={icon.label}>
          {typeof icon.icon === 'string' ? useIcon(icon.icon) : icon.icon}
          {icon.label}
        </StyledIcon>
      ))}
    </StyledIconList>
  )
}



// WEBPACK FOOTER //
// ./src/components/IconList/index.js